import { Store, SerializedData } from "bernie-core";
import { observable, action } from "mobx";

import { Logger } from "bernie-logger";

export class ThemeSelectorStore extends Store {
  public constructor(state: SerializedData, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @observable
  public activeTheme = "beach";

  @action
  public updateActiveTheme(newTheme: string) {
    this.activeTheme = newTheme;
  }
}
